import styled from '@emotion/styled';

export const Container = styled.div`
  .search {
    margin-bottom: 10px;
  }
  .ant-list-item-meta {
    align-items: center;
  }
  .ant-list-item-meta-title > a {
    color: #148ffd;
  }
    .ant-list-item-meta-title > a:hover {
    color: #70b5ff;
  }
  .ant-list-item-meta-avatar {
    img {
      width: 80px;      
      height: 60px;
      object-fit: cover;
    }
  }
`;